import { useEffect, useRef, useState } from "react";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";

interface HearNameButtonProps {
  /** The talent's recorded name (a signed link marketplace sends only when one was recorded). */
  url: string;
  name: string;
}

/** A speaker next to the talent's name that plays how they say it (product 2026-10-28). */
function HearNameButton({ url, name }: HearNameButtonProps) {
  const audio = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  useEffect(
    () => () => {
      audio.current?.pause();
      audio.current = null;
      setPlaying(false);
    },
    [url]
  );

  const play = () => {
    if (!audio.current) {
      audio.current = new Audio(url);
      audio.current.onended = () => setPlaying(false);
      audio.current.onerror = () => setPlaying(false);
    }
    audio.current.currentTime = 0;
    setPlaying(true);
    // A blocked or failed play only resets the button.
    audio.current.play().catch(() => setPlaying(false));
  };

  return (
    <button
      type="button"
      className={`hear-name${playing ? " hear-name--playing" : ""}`}
      aria-label={`Hear how ${name} says their name`}
      title="Hear name"
      onClick={play}
    >
      <VolumeUpOutlinedIcon aria-hidden />
    </button>
  );
}

export default HearNameButton;
